import { __assign } from "tslib";
import React from 'react';
import { BdiWrapper } from '../../components/bdi-wrapper';
import { LinkWrapper } from '../../components/link-wrapper';
import { contactContainerNew } from './styles';
var FooterLink = function (_a) {
    var active = _a.active, href = _a.href, text = _a.text, textColor = _a.textColor, _b = _a.style, style = _b === void 0 ? {} : _b;
    return active ? (React.createElement("div", { style: __assign(__assign({}, contactContainerNew), style) },
        React.createElement("a", { style: {
                color: textColor,
            }, target: "_blank", className: "so-global-footer-text html-emails-footer-link", href: href ? href : undefined },
            React.createElement(LinkWrapper, { fontWeight: "inherit" },
                React.createElement(BdiWrapper, { text: text }))))) : null;
};
export default FooterLink;
//# sourceMappingURL=footer-link.js.map